import AdminApiService from "src/api/AdminApiService";
import { useQuery } from "@tanstack/react-query";
import { QueryTypes } from "./shared";
import AzureIoTEdgeDeviceDTO from "src/models/AzureIoTEdgeDeviceDTO";

//This only gets the string names. It will be deprecated soon
export const useGetAllAzureIoTEdgeDevicesQuery = (options: QueryTypes = {}) => {
    const getAllAzureIoTEdgeDevicesQueryKey = ["getAllAzureIoTEdgeDevices"];

    const getAllAzureIoTEdgeDevicesQuery = useQuery<AzureIoTEdgeDeviceDTO[]>([getAllAzureIoTEdgeDevicesQueryKey],
        async (q) => {
            return await AdminApiService.getAllAzureIoTEdgeDevices(q.signal);
        },
        {
            enabled: options?.enabled,
            refetchInterval: options?.refetchInterval,
            refetchOnWindowFocus: options?.refetchOnWindowFocus,
        });

    return { getAllAzureIoTEdgeDevicesQuery, getAllAzureIoTEdgeDevicesQueryKey }
}